var _style, _g, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbrapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 229.5 113.3",
    style: {
      enableBackground: "new 0 0 229.5 113.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00773D;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#004994;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.1,68l-2-9.4l-1,4.8c-0.2,1-0.2,2-0.5,4.6h-8.2c0-1,0.2-2,0.5-3h-0.1c-2,2.4-4.9,3.8-8,3.7 c-5.4,0-7.5-2.9-6.5-7.5c1.3-5.5,6.8-7.8,14.2-7.8h2.7c0.4-2,1.5-4.9-2-4.7c-2.1,0.1-3.2,2.1-3.5,3.5h-8.1 c0.6-2.8,2.6-5.1,5.3-6.1c2.6-1,5.3-1.4,8.1-1.4c1.4,0,2.9,0.2,4.3,0.6l-0.6-2.9c-2.3-10.9-13.3-19.7-24.1-19.7H86.4l5.5,25.8 l2.8-13h8.6l-2.7,12.3h0.1c2-2,4.7-3.1,7.6-3.1c7,0,8.9,5.3,7.6,11.7c-1.5,6.9-5.7,12.3-13.2,12.3c-2.6,0-5.4-1.7-5.5-4h-0.2 l-1,3.3l0.6,3c2.3,10.9,13.3,19.7,24.1,19.7H163L158.1,68z M125.4,58.9l-2,9.1h-8.6l3.6-16.8c0.4-1.9,0.8-3.9,1-5.8h8.7l-0.8,4.2 h0.1c1.8-3.7,4.9-5,8.7-4.9l-1.6,7.3c-0.6-0.1-1.2-0.1-1.8-0.1C128.2,51.9,126.1,54.6,125.4,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,56.6c0.6-2.8,1.1-7-2.6-7c-3.9,0-5.1,4.3-5.8,7.4c-0.6,2.5-0.7,6.7,2.4,6.7 C104.8,63.7,106.3,59.5,106.9,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.7,60.7c-0.4,1.2,0.3,2.5,1.5,2.9c0.2,0.1,0.5,0.1,0.7,0.1c3.7,0,4.8-3.5,5.4-6.5 c-1.8,0-3.5-0.1-4.8,0.5C142.2,58.3,141,59.1,140.7,60.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.8,60.7c0.3-1.6,1.5-2.4,2.9-3c1.3-0.6,3-0.5,4.8-0.5c-0.7,3-1.7,6.5-5.4,6.5c-1.3,0-2.3-1-2.4-2.2 C189.7,61.2,189.7,61,189.8,60.7z M203.7,68c0.3-2.7,0.3-3.7,0.5-4.6l2.5-11.7c1.2-5.1-4-7-8.6-7c-2.8-0.1-5.5,0.4-8.1,1.4 c-2.7,1-4.7,3.3-5.3,6.1h8.1c0.3-1.3,1.4-3.4,3.5-3.5c3.5-0.1,2.4,2.7,2,4.7h-2.7c-7.4,0-13,2.3-14.2,7.8 c-1.1,4.6,1.1,7.5,6.5,7.5c3.1,0.1,6.1-1.3,8-3.7h0.1c-0.3,1-0.5,2-0.5,3H203.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "47.5,68 48.8,61.7 33,61.7 34.5,54.8 49,54.8 50.4,48.4 35.9,48.4 37.3,41.7 53.1,41.7 54.5,35.4  29.7,35.4 22.6,68  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.7,45.3h-8.6l-6.7,31.3h8.6l2.4-11.3h0.1c1.2,2.1,3.3,3.3,5.7,3.4c7.3,0,11.8-5.7,13.3-12.3 c1.3-6-0.4-11.7-7.2-11.7c-3.2-0.1-6.2,1.4-8.2,3.9H166L166.7,45.3L166.7,45.3z M170,49.6c3.6,0,3.2,4.2,2.6,7 c-0.6,2.9-2,7-5.7,7c-3.6,0-3.2-4.2-2.6-7C164.9,53.8,166.3,49.6,170,49.6L170,49.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.3,44.6c-3.5,0.1-6.8,1.7-9,4.3c-0.4-2.8-3.2-4.2-5.9-4.2c-3.5-0.1-6.8,1.5-8.9,4.3h-0.1l0.7-3.7h-8.5 c-0.2,2-0.6,3.9-1,5.8L49,68h8.6l2.8-13c0.1-0.3,0.5-4.9,4.8-4.9c2.7,0,2.7,2.4,2.3,4.6L64.6,68h8.6L76,55c0.1-0.3,0.5-4.9,4.8-4.9 c2.6,0,2.7,2.4,2.3,4.6L80.2,68h7.4l4.2-19.5C90.9,46,88.5,44.6,85.3,44.6z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134.1,
    y1: 90.6,
    x2: 138.1,
    y2: 113.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbrapa);
export default __webpack_public_path__ + "static/media/embrapa.5783bc900c6575ffbe2fa3d8522a8ad7.svg";
export { ForwardRef as ReactComponent };